import { render, staticRenderFns } from "./teacherHeader.vue?vue&type=template&id=3ef34968&scoped=true"
import script from "./teacherHeader.vue?vue&type=script&lang=js"
export * from "./teacherHeader.vue?vue&type=script&lang=js"
import style0 from "./teacherHeader.vue?vue&type=style&index=0&id=3ef34968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef34968",
  null
  
)

export default component.exports